<template>
    <div class="app-container">
        <div
        class="question-container">
            <pang-title :text="$router.lang.get('客服  中心')" eng="Customer Service"/>
            <div v-if="!question.answer" class="edit-butt-container">
                <div>
                    <pang-butt @click="gotoEdit" :text="$router.lang.get('修改')" icon="fa fa-edit" :loading="loading"/>
                </div>
            </div>
            <pang-article-detail
            :title="'['+QUESTION_TYPE_CHOICES[question.question_type]+']'+question.article.title"
            :author="question.article.author_nickname"
            :create_at="question.create_at"
            :content="mergeContent(question)"/>
            <pang-comment v-if="question.answer" :aritcleid="question.answer.article.id" :subCommentDisabled="true"/>
        </div>
    </div>
</template>

<script>

import { useScreenState } from '../../store';
import { PangTitle, PangArticleDetail, PangButt, PangComment } from '../../components'
import enums from '../../utils/enums.js'
import request from '../../api/request'
import message from '../../utils/message'

export default {
    name: 'Detail',
    components: {
        PangTitle,
        PangArticleDetail,
        PangButt,
        PangComment,
    },
    data () {
        return {
            QUESTION_TYPE_CHOICES: enums.QUESTION_TYPE_CHOICES,
            screenState: useScreenState(),
            loading: false,
          staticUrl: request.staticUrl,
            question:  {
                id: 1,
                article: {
                    content: '',
                    title: ''},
                question_type: 1,
                create_at: '',
            },
        };
    },
    methods: {
        getRecent (id) {
            let _this = this
            request.get('/questions/' + id, {}, this).then(function (res) {
                if (res.status == 200) {
                    if (res.data.article.author_id != _this.screenState.user.id)
                        _this.$router.replace('/404')
                    _this.question = res.data
                }
                else if (res.status == 404) {
                    _this.$router.replace('/404')
                }
                else {
                    message.resMessage(res, _this)
                }
            })
        },
        gotoEdit () {
            this.$router.push('/customerservice/question/' + this.question.id + '/edit' )
        },
        mergeContent (question) {
            let content = '<div class="attri-container">' + this.$router.lang.get('伺服器：全服通用') + '</div>'
            if (question.role) {
                content += '<div class="attri-container">' + this.$router.lang.get('角色：') + question.role + '</div>'
            }
            if (question.cover)
                content += '<p><img srv=\'' + this.staticUrl + '/static'+question.cover+'\'/></p>'
            content += question.article.content
            if (question.answer) {
                content += '<div class="reply-title">' + this.$router.lang.get('回報') + ' <span>(' + question.answer.create_at.slice(0, 10) + ')</span></div>' + question.answer.article.content
            }
            return content
        },
    },
    beforeMount () {
        if (!this.screenState.user) {
            this.$router.replace({ path: '/account/login', query: {returnurl: this.$route.fullPath}});
        }
    },
    mounted () {
        if (this.screenState.user)
            this.getRecent(this.$route.params.id)
    },
}
</script>

<style>
.reply-title {
    font-size: 28px;
    font-weight: 400;
    margin: 80px auto;
}
.reply-title  > span {
    color: #A8AEB3;
    font-size: 16px;
}

.attri-container {
    margin: 20px 0;
}

.edit-butt-container {
    max-width: 1040px;
    width: 90vw;
    margin: auto;
}

.edit-butt-container > div  {
    width: 150px;
    margin-left: auto;
}

</style>
